module.exports = __webpack_public_path__ + "static/media/cuncaicha_preview.bd278fee.png";